import type { ComponentProps } from 'react';
import { cn } from '@poseidon/components/cn';
import React from 'react';

type ContentSectionProps = Omit<ComponentProps<'div'>, 'size'> & {
  size?: 'small';
};

export const ContentSection = ({ children, size, className, ...props }: ContentSectionProps) => (
  <div
    className={cn(
      'flex flex-col gap-2 overflow-visible max-w-[1200px] [&_+_&]:mt-16',
      { 'max-w-[760px] [&_+_&]:mt-10': size === 'small' },
      className,
    )}
    {...props}>
    {children}
  </div>
);


export const ContentSection2 = ({ children, size, className, ...props }: ContentSectionProps) => (
  <div
    className={cn(
      'flex flex-col gap-4 overflow-visible max-w-[1200px] [&_+_&]:mt-8',
      { 'max-w-[760px] [&_+_&]:mt-10': size === 'small' },
      className,
    )}
    {...props}>
    {children}
  </div>
);